import { pluralize } from 'lib/helpers';

export const AVERAGE_DAYS_TO_CREDIT = 8;

export const getComparisonText = (procrastinationScore: number) => {
  if (procrastinationScore === 0) {
    return {
      days: 'ZERO',
      comparison: 'AMAZING!',
      speed: "YOU'RE A STAR",
      showThanTheAverage: false,
      subtitle: '(THE AVERAGE GONDOLA USER TOOK 2 WEEKS!)',
    };
  }

  if (procrastinationScore === AVERAGE_DAYS_TO_CREDIT) {
    return {
      days: procrastinationScore,
      comparison: 'EXACTLY',
      speed: 'AVERAGE.',
      showThanTheAverage: false,
      subtitle: "(IS THIS HOW YOU'RE DOING EVERYTHING IN LIFE?)",
    };
  }

  const isFaster = procrastinationScore < AVERAGE_DAYS_TO_CREDIT;
  const difference = Math.abs(procrastinationScore - AVERAGE_DAYS_TO_CREDIT);

  return {
    days: procrastinationScore,
    comparison: `${difference} ${pluralize('day', difference)}`,
    speed: isFaster ? 'FASTER' : 'SLOWER',
    showThanTheAverage: true,
    subtitle: "(IS THIS HOW YOU'RE DOING EVERYTHING IN LIFE?)",
  };
};
